<template>
  <b-container fluid>
    <b-breadcrumb :items="items" />

    <b-form inline class="mt-5">
      <label class="sr-only" for="catalogueDescrption">Description</label>
      <b-form-input
        class="mb-2 mr-sm-2 mb-sm-0"
        id="catalogueDescription"
        placeholder="Description"
        v-model="catalogue.description"
      ></b-form-input>
      <b-button :disabled="saving" variant="primary" @click="updateCatalogue"
        >Save</b-button
      >
    </b-form>

    <b-table
      striped
      hover
      ref="table"
      class="mt-5"
      :fields="fields"
      :items="dataProvider"
      small
    >
      <template slot="actions" slot-scope="cell">
        <b-button-group>
          <b-button
            size="sm"
            class="align-top"
            variant="outline-secondary"
            @click="moveUp(cell.item)"
          >
            <icon name="arrow-up" class="align-middle"></icon>
          </b-button>
          <b-button
            size="sm"
            class="align-top"
            variant="outline-secondary"
            @click="moveDown(cell.item)"
          >
            <icon name="arrow-down" class="align-middle"></icon>
          </b-button>
          <b-button
            size="sm"
            class="align-top"
            variant="outline-secondary"
            :to="{ name: 'EditPrintGroup', params: { id: cell.item.id } }"
          >
            <icon name="edit" class="align-middle"></icon>
          </b-button>
          <click-confirm>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click.stop="deletePrintGroup(cell.item)"
            >
              <icon name="remove" class="align-middle"></icon>
            </b-button>
          </click-confirm>
        </b-button-group>
      </template>
    </b-table>

    <b-button-toolbar class="mt-5 float-right">
      <b-button-group>
        <b-button
          v-b-modal.createPrintGroup
          variant="primary"
          class="btn-circle btn-lg"
          ><icon name="plus" class="align-middle"
        /></b-button>
      </b-button-group>
    </b-button-toolbar>

    <b-modal
      id="createPrintGroup"
      title="Create Printer Group"
      @ok="createPrintGroup"
    >
      <b-input placeholder="Description" v-model="printGroup.description">
      </b-input>
    </b-modal>
  </b-container>
</template>

<script>
import PrintersApi from "@/printers_api";
import Notify from "@/notify";
import ClickConfirm from "click-confirm";

export default {
  components: {
    "click-confirm": ClickConfirm,
  },
  mixins: [Notify],
  watch: {
    $route(to) {
      this.refresh(to.params.id);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.refresh(to.params.id);
    });
  },
  data() {
    return {
      fields: ["description", "actions"],
      saving: false,
      isBusy: false,
      catalogue: {},
      printGroups: [],
      printGroup: {
        description: "",
      },
      id: null,
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Catalogue",
          href: "#",
          active: true,
        },
      ],
    };
  },
  async created() {
    this.refresh(this.id);
  },
  methods: {
    dataProvider() {
      if (!Number.isInteger(parseInt(this.id, 0))) {
        return [];
      }
      const promise = new PrintersApi(
        this.$auth.getAccessToken()
      ).retrievePrintGroups(this.id);
      return promise.then((response) => {
        const items = response.data;
        return items || [];
      });
    },
    async refresh(id) {
      try {
        if (!Number.isInteger(parseInt(id, 0))) {
          return;
        }
        this.id = id;
        const response = await new PrintersApi(
          this.$auth.getAccessToken()
        ).retrieveCatalogue(id);
        this.catalogue = response.data;

        this.$refs.table.refresh();
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async updateCatalogue() {
      this.saving = true;
      try {
        try {
          await new PrintersApi(this.$auth.getAccessToken()).updateCatalogue(
            this.id,
            this.catalogue
          );
        } catch (e) {
          this.notifyError(e.message);
        }
      } finally {
        this.saving = false;
      }
    },
    async moveUp(item) {
      if (item.position === 0) {
        return;
      }

      try {
        await new PrintersApi(this.$auth.getAccessToken()).updatePrintGroup(
          item.id,
          {
            position: item.position - 1,
          }
        );
        this.$refs.table.refresh();
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async moveDown(item) {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).updatePrintGroup(
          item.id,
          {
            position: item.position + 1,
          }
        );
        this.$refs.table.refresh();
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async createPrintGroup() {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).createPrintGroup(
          this.id,
          this.printGroup
        );
        this.resetModal();
        this.refresh(this.id);
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    async deletePrintGroup(item) {
      try {
        await new PrintersApi(this.$auth.getAccessToken()).deletePrintGroup(
          item.id
        );
        this.refresh(this.id);
      } catch (e) {
        this.notifyError(e.message);
      }
    },
    resetModal() {
      this.printGroup = { description: "" };
    },
  },
};
</script>

<style>
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}
.btn-circle.btn-lg {
  width: 50px;
  height: 50px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 25px;
}
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  font-size: 24px;
  line-height: 1.33;
  border-radius: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/printers/CatalogueEdit.vue